import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const IconDownload = () => {
    return (
        <svg
            style={{ width: '46px', height: '46px' }}
            viewBox='0 0 46 46'
            xmlns='http://www.w3.org/2000/svg'>
            <title>Download</title>
            <rect
                fill='#FC5200'
                height='46'
                rx='4'
                width='46' />
            <g clipPath='url(#clip0_102_596)'>
                <path
                    clipRule='evenodd'
                    d='M17 17L29 17L23 23L17 17Z'
                    fill='white'
                    fillRule='evenodd' />
            </g>
            <line
                stroke='white'
                x1='29'
                x2='17'
                y1='29.5'
                y2='29.5' />
            <defs>
                <clipPath id='clip0_102_596'>
                    <rect
                        fill='white'
                        height='12'
                        transform='translate(29 17) rotate(90)'
                        width='6' />
                </clipPath>
            </defs>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {};

IconDownload.propTypes = propTypes;

export default IconDownload;
